exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_emptyList__1cZJE{padding:.5rem 1rem;font-size:.875rem;color:#9e9e9e}.style_actionsMenu__3x1Ih{display:flex;justify-content:flex-end;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"emptyList": "style_emptyList__1cZJE",
	"actionsMenu": "style_actionsMenu__3x1Ih"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/RemoveItemsList/style.less
// module id = 1772
// module chunks = 8